import { useLingui } from '@lingui/react/macro';
import { memo } from 'react';

import { Card } from '@/components/card/Card';
import { SchemaFields } from '@/components/form/SchemaFields';
import { useFieldsSchema } from '@/components/form/useFieldsSchema';

export const TierConfigFields = memo(function TierConfigFields() {
  const { t } = useLingui();
  const { schema: detailsSchema } = useFieldsSchema(
    [
      {
        name: 'name',
        label: t`Name`,
        required: true,
      },
      {
        name: 'url',
        label: t`URL`,
        uiProps: {
          placeholder: t`https://example.com`,
        },
      },
    ],
    [t],
  );

  return (
    <Card title={t`Basic details`}>
      <SchemaFields schema={detailsSchema} />
    </Card>
  );
});
